<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
    :outlined="outlined"
    :dark="dark"
    :color="color"
    :height="height"
    class="pt-3 pb-3"
  >
    <v-list-item
      two-line
      :style="{'text-align': align}"
    >
      <v-list-item-content>
        <v-list-item-title style="font-size: 40px;line-height: 36px">
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle style="font-size: 14px; line-height: 21px; white-space: normal !important;">
          {{ subTitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "InfoCard",
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    subTitle: {
      type: [String, Number],
      default: ''
    },
    align: {
      type: String,
      default: 'center'
    },
    height: {
      type: [String, Number],
      default: '120px'    // override the default value 'undefined' in v-card
    },
    color: {
      type: String,
      default: '#0E2D58'  // override the default value 'undefined' in v-card
    },
    outlined: {
      type: Boolean,
      default: true       // override the default value 'false' in v-card
    },
    dark: {
      type: Boolean,
      default: true       // override the default value 'false' in v-card
    }
  }
}
</script>
